var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcimene(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#51B0CB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.9,369.7c0-9.8,6.8-16.9,16.8-16.9c9.7,0,16.8,6.8,16.8,16.9c0,10-7.1,16.9-16.8,16.9 C148.8,386.6,141.9,379.5,141.9,369.7z M168.7,369.7c0-6.2-4.3-10.8-10-10.8c-6,0-10,4.8-10,10.8c0,6,4.1,10.8,10,10.8 C164.5,380.5,168.7,375.9,168.7,369.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180,369.8c0-9.4,6-17,16.7-17c4.7,0,9.6,2,13.2,6.4l-4.8,4c-2.1-2.6-4.9-4.2-8.3-4.2c-5.6,0-9.9,4.2-9.9,10.8 c0,6.1,4.1,10.6,10,10.6c3.4,0,6.3-1.7,8.3-4.2l4.8,4.1c-2.8,3.5-7.3,6.2-13.1,6.2C187.7,386.6,180,380.7,180,369.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215.2,353.2h6.7v33h-6.7V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.3,353.2h6.6L246,372h0.1l10.1-18.8h6.6v33h-6.5v-20.4h-0.1l-8,14.2h-4.2l-8-14.2h-0.1v20.5h-6.5V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270,353.2h21.1v5.8h-14.7v8h11.7v5.7h-11.7v7.7h15.6v5.8H270V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.8,353.2h6.4l14.8,22.3h0.1v-22.3h6.5v33H319l-14.7-21.8h-0.1v21.8h-6.5V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.8,353.2h21.1v5.8h-14.7v8H351v5.7h-11.7v7.7h15.6v5.8h-22.1V353.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.8,150.1H200c-1.1,0-2,0.6-2.8,1.8s-1.2,3.1-1.2,5.8v73.7c0,2.8,0.4,4.7,1.2,5.9c0.8,1.1,1.7,1.7,2.8,1.7 h0.9c1.1,0,2-0.6,2.8-1.7c0.8-1.1,1.2-3.1,1.2-5.9v-73.7c0-2.7-0.4-4.6-1.2-5.8C202.9,150.7,201.9,150.1,200.8,150.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.7,98.7c-54.4,0-98.5,44.1-98.5,98.5s44.1,98.5,98.5,98.5s98.5-44.1,98.5-98.5S302.1,98.7,247.7,98.7z  M215,232.8c0,2.6-0.4,4.8-1.2,6.6s-1.8,3.3-3,4.5s-2.7,2.1-4.3,2.6s-3.3,0.8-4.8,0.8h-2.4c-1.7,0-3.3-0.3-4.9-0.8 c-1.6-0.5-3-1.4-4.2-2.6c-1.2-1.2-2.3-2.7-3-4.5c-0.8-1.8-1.2-4-1.2-6.6v-76.6c0-2.6,0.4-4.8,1.2-6.6s1.8-3.4,3-4.5 c1.2-1.2,2.7-2.1,4.2-2.6c1.6-0.5,3.2-0.8,4.9-0.8h2.4c1.6,0,3.2,0.3,4.8,0.8s3.1,1.4,4.3,2.6c1.2,1.2,2.2,2.7,3,4.5s1.2,4,1.2,6.6 V232.8z M256.4,184.5h-10.1v-26.9c0-2.7-0.4-4.6-1.2-5.7c-0.8-1.1-1.7-1.7-2.8-1.7h-0.9c-1.1,0-2,0.5-2.8,1.6s-1.2,3.1-1.2,6v73.7 c0,2.8,0.4,4.7,1.2,5.9c0.8,1.1,1.7,1.7,2.8,1.7h0.9c1.1,0,2-0.6,2.8-1.7c0.8-1.1,1.2-3.1,1.2-5.9v-26.9h10.1V233 c0,2.6-0.4,4.8-1.2,6.6s-1.8,3.3-3,4.5s-2.7,2.1-4.3,2.6s-3.3,0.8-4.8,0.8h-2.4c-1.7,0-3.3-0.3-4.9-0.8c-1.6-0.5-3-1.4-4.2-2.6 c-1.2-1.2-2.3-2.7-3-4.5c-0.8-1.8-1.2-4-1.2-6.6v-76.6c0-2.6,0.4-4.8,1.2-6.6s1.8-3.4,3-4.5c1.2-1.2,2.7-2.1,4.2-2.6 c1.6-0.5,3.2-0.8,4.9-0.8h2.4c1.6,0,3.2,0.3,4.8,0.8s3.1,1.4,4.3,2.6c1.2,1.2,2.2,2.7,3,4.5s1.2,4,1.2,6.6V184.5z M309.5,246.5 h-8.3v-73.2H301l-8.2,73.2h-7.4l-8.2-73.2H277v73.2h-8.5v-104h13.1l7.3,65.8h0.2l7.4-65.8h12.9v104H309.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcimene);
export default __webpack_public_path__ + "static/media/OCIMENE.d6f56af7d7cc568c29cac198b67e00ca.svg";
export { ForwardRef as ReactComponent };